export default function UpdownButton() {
    return (
        <div title="Move task up down" className="p-1 bg-gray-200 border hover:bg-gray-100 task-sort-handler cursor-move">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
            </svg>
        </div>
    );
}
